import React, { useState, useEffect, useContext, useRef } from 'react';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { useNavigate, Link, useLocation } from 'react-router-dom';
import FormPermissionService from "../../../Setup/controller/FormPermissionController/FormPermissionController";
import JobPartsService from "../../Controller/JobPartsController";
import CreateJobModel from "./CreateJobPart";
import JobService from "../../Controller/JobController";

import Swal from 'sweetalert2';
import PartService from "../../../Parts/Controller/PartController";
import CurrencyService from "../../../Setup/controller/CurrencyController/CurrencyController";
import HelpSite from "../../../Common/HelpLink";
import CurrencyConverter from '../../../../config/CurrencyConverter';
import { convertCurrency } from "../../../Purchasing/View/PurchaseOrderForms/CurrencyConverter";
import PartSelectionModal from "./PartSelectionModal";
import { handleChange, handleSubmit } from "../../Controller/CreateJobPartController";
import Cookies from "js-cookie";
function PartStatus({ part }) {

    const getStatus = () => {
        if (part.StockType?.toString() === "0" || parseFloat(part.vc_UnitOfSale) === parseFloat(part.dec_QtyAllocated)) {
            return "Full";
        } else if (parseFloat(part.dec_QtyAllocated) === parseFloat("0")) {
            return "Pending";
        } else {
            return "PART";
        }
    };

    return <span>{getStatus()}</span>;
}
function JobPartList({ JobID }) {
    const navigate = useNavigate();
    JobID = localStorage.getItem('JobID');

    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const RoleID = localStorage.getItem('RoleID');
    const HelpLink = localStorage.getItem('HelpLink');
    const pathname = "/job/job-part";

    const FormAction = "/JobsList";
    //FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);
    const [currentjobPart, setCurrenJobPart] = useState(null);
    const [modalInstance, setModalInstance] = useState(null);
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme === "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [jobPartsList, setJobPartsData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [isModalDepot, setIsModalDepot] = useState(false);
    const [selectedDepot, setSelectedDepot] = useState("");
    const [IssueStockID, setIssueStockID] = useState(0);
    const [depots, setSelectedDepotList] = useState([]);
    const [isClosed, SetIsClosed] = useState("0");

    const [BaseCurrency, setBaseCurrency] = useState(null);
    const [currencyList, setCurrencies] = useState([]);
    const [ConvRate, setConvRate] = useState('1.00');
    const [selectedParts, setSelectedParts] = useState([]);
    const [showPartModal, setShowPartModal] = useState(false);
    const [partList, setPartData] = useState([]);
    const [selectedPartID, setSelectedPartID] = useState(null);
    const [errors, setErrors] = useState({});
    const UserID = localStorage.getItem("UserID");
    const CompanyID = localStorage.getItem("CompanyID");

    const [currentPage, setCurrentPage] = useState(1); // Current page
    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);
    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const setSortConfigInCookie = (config) => {
        Cookies.set(`JobPartSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`JobPartSort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());

    const [formData, setFormData] = useState({
        FK_Stock_ID: 0,
        FK_Issue_ID: JobID
    });
    const fetchJobParts = async (page, size) => {
        try {
            console.log("Fetching Job Parts for JobID:", JobID);

            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();

            const jobData = await JobPartsService.GetAllIssueStock(JobID, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), "", searchOptions.toString(), ""
            );

            const jobPartData = await JobPartsService.JobsPartCount(JobID,searchQuery,searchColumns);

            console.log("Fetched Job Parts:", jobData);

            setJobPartsData(Array.isArray(jobData) ? [...jobData] : []);
            setPOCount(jobPartData[0].TotalRecords);
            setTotalPages(Math.ceil(jobPartData[0].TotalRecords / pageSize));
            const listOfCurrency =
                await CurrencyService.DefaultCurrency(
                    redirectCallback
                );

            if (listOfCurrency?.length > 0) {
                setBaseCurrency(listOfCurrency[0].Symbol);
            }

        } catch (error) {
            console.error('Error fetching Job Parts:', error);
        }
    };

    useEffect(() => {
        fetchJobDetail();
    }, [JobID]);

    useEffect(() => {
        SetIsClosed(localStorage.getItem("Closed"));
        fetchJobParts(currentPage, pageSize);
    }, [JobID, localStorage.getItem("Closed"),currentPage]);

    const fetchJobDetail = async () => {
        try {
            const redirectCallback = () => navigate('/');

            if (JobID > 0) {

                const jobDetail = await JobService.GetJobByID(redirectCallback, JobID);
                await fetchCurrencyConvRate(jobDetail[0].Symbol);
                SetIsClosed(jobDetail[0].IsCompleted);

            }
        } catch (error) {
            console.error('Error fetching agreement details:', error);
        }
    };
    const fetchCurrencyConvRate = async (newCurrencySymbol) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const rateConv = await convertCurrency(BaseCurrency, newCurrencySymbol, currencyList, "0");
            setConvRate(rateConv);
        } catch (error) {
            console.error('Error fetching Agreement Notifications:', error);
        }
    };

    const handleCreateJobPartClick = () => {
        setCurrenJobPart(null);
        //setIsModalOpen(true);
        setShowPartModal(true);
    };

    const handleCloseModal = () => {
        setShowPartModal(false);
    };


    const handleDeleteClick = async (event, part) => {
        event.stopPropagation();

        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (!result.isConfirmed) {
            return;
        }

        try {

            // ============================================
            // NEW / UNSAVED PART
            // ============================================
            if (part.IsNew === true || part.IsTextRow === true) {

                setSelectedParts(prevParts =>
                    prevParts.filter(
                        selectedPart =>
                            selectedPart.tempID !== part.tempID
                    )
                );

                Swal.fire({
                    title: 'Removed!',
                    text: 'The item has been removed from the list.',
                    icon: 'success',
                    timer: 1000,
                    showConfirmButton: false
                });

                return;
            }



            // ============================================
            // EXISTING / SAVED PART
            // ============================================
            await JobPartsService.DeleteJobPart(
                redirectCallback,
                part.PK_IssueStock_ID
            );

            // Remove from React state immediately
            setJobPartsData(prevParts =>
                prevParts.filter(
                    existingPart =>
                        String(existingPart.PK_IssueStock_ID) !==
                        String(part.PK_IssueStock_ID)
                )
            );

            // Update JobCostID
            let JobCostID = parseInt(
                localStorage.getItem('JobCostID') || '0',
                10
            );

            JobCostID += 1;

            localStorage.setItem(
                'JobCostID',
                JobCostID.toString()
            );

            Swal.fire({
                title: 'Deleted!',
                text: 'Your record has been deleted.',
                icon: 'success',
                timer: 1000,
                showConfirmButton: false
            });

        } catch (error) {

            console.error('Error deleting job part:', error);

            Swal.fire(
                'Error!',
                'There was a problem deleting the record.',
                'error'
            );
        }
    };
    const handleJobSaveClick = async (JobID) => {
        try {
            debugger;
            const jobData = await JobPartsService.UpdatePendingParts(redirectCallback, JobID);

            await fetchJobParts(currentPage, pageSize);
            let JobCostID = localStorage.getItem('JobCostID');
            JobCostID = JobCostID + 1;
            localStorage.setItem('JobCostID', JobCostID);
            redirectUserList();

        } catch (error) {
            console.error('Error deleting Site:', error);
        }

    };
    const redirectUserList = () => {
        navigate('/JobsList?saved=true');
    };
    const handleSuccess = async () => {
        setSelectedParts([]);
        setShowPartModal(false);

        fetchJobParts(currentPage, pageSize);
    };
    const handelSelectDepot = async (event, PK_IssueStock_ID, PartID) => {
        event.stopPropagation();
        setIssueStockID(PK_IssueStock_ID);
        await fetchStockLocations(PartID);
        setIsModalDepot(true);
    };

    // Handle closing the modal
    const closeModal = () => {
        setIsModalDepot(false);
    };

    const fetchStockLocations = async (PartID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const listOfLocations = await PartService.GetPartLocation(redirectCallback, PartID);
            setSelectedDepotList(listOfLocations);
        } catch (error) {
            console.error('Error fetching locations:', error);
        }
    };

    const handlePartSelect = (parts) => {

        const partsArray = Array.isArray(parts)
            ? parts
            : [parts];

        const newParts = partsArray.map(part => ({
            ...part,
            tempID: `text-${Date.now()}-${Math.random()}`,
            LocationID: 0,
            DepotName: "",
            DepotQuantity: 0,

            vc_UnitOfSale: part.vc_UnitOfSale || 1,

            // VERY IMPORTANT
            IsNew: true,
            IsText: false
        }));

        setSelectedParts(prev => [
            ...prev,
            ...newParts
        ]);
    };

    const allParts = [
        ...jobPartsList,
        ...selectedParts
    ];
    const handleQuantityChange = (stockID, value) => {
        const decimalRegex = /^\d*\.?\d*$/;

        if (!decimalRegex.test(value)) {
            return;
        }

        setSelectedParts(prevParts =>
            prevParts.map(part =>
                part.PK_Stock_ID === stockID && !part.IsTextRow
                    ? {
                        ...part,
                        vc_UnitOfSale: value
                    }
                    : part
            )
        );
    };
    const handleSelectDepotForNewPart = async (PartID) => {
        await fetchStockLocations(PartID);

        setSelectedPartID(PartID);
        setSelectedDepot("");
        setIsModalDepot(true);
    };
    const handleFormSubmit = async (event) => {
        event.preventDefault();
        debugger;
        if (selectedParts.length === 0) {
            Swal.fire(
                'Warning!',
                'Please select at least one part.',
                'warning'
            );
            return;
        }

        // Validate quantity and depot
        const invalidPart = selectedParts.find(part => {

            // Free text row
            if (part.IsTextRow) {
                return (
                    !part.vc_StockCode?.trim() ||
                    !part.vc_Description?.trim() ||
                    !part.vc_UnitOfSale ||
                    parseFloat(part.vc_UnitOfSale) <= 0 ||
                    part.mon_SalesPrice === "" ||
                    parseFloat(part.mon_SalesPrice) < 0
                );
            }

            // Normal stock part
            return (
                !part.vc_UnitOfSale ||
                parseFloat(part.vc_UnitOfSale) <= 0 ||
                (
                    part.StockType?.toString() === "1" &&
                    (
                        !part.LocationID ||
                        parseInt(part.LocationID) <= 0
                    )
                )
            );
        });

        if (invalidPart) {
            Swal.fire(
                'Warning!',
                'Please select a depot or enter a valid quantity for all parts.',
                'warning'
            );
            return;
        }

        try {
            const formDataWithParts = {
                formData: {
                    ID: 0,
                    FK_Issue_ID: JobID
                },
                selectedParts: selectedParts
            };

            debugger;

            const Message = await handleSubmit(
                event,
                formDataWithParts,
                setFormData,
                setErrors
            );

            if (Message === "Data saved successfully") {

                let JobCostID = parseInt(
                    localStorage.getItem('JobCostID') || '0',
                    10
                );

                JobCostID += 1;
                localStorage.setItem('JobCostID', JobCostID.toString());

                setSelectedParts([]);

                await fetchJobParts(currentPage, pageSize);

                Swal.fire(
                    'Success!',
                    'Parts saved successfully.',
                    'success'
                );
            } else {
                Swal.fire(
                    'Warning!',
                    Message || 'Unable to save the record.',
                    'warning'
                );
            }

        } catch (error) {
            console.error('Error submitting form:', error);

            Swal.fire(
                'Error!',
                'An error occurred while submitting the form. Please try again.',
                'error'
            );
        }
    };

    const handleDepotSubmit = () => {

        if (!selectedDepot) {
            Swal.fire(
                'Warning!',
                'Please select a depot.',
                'warning'
            );
            return;
        }

        const selectedDepotData = depots.find(
            depot =>
                depot.PK_StockLocation_ID.toString() ===
                selectedDepot.toString()
        );

        if (!selectedDepotData) {
            Swal.fire(
                'Error!',
                'Selected depot could not be found.',
                'error'
            );
            return;
        }

        // New temporary part
        if (selectedPartID !== null) {

            setSelectedParts(prevParts =>
                prevParts.map(part =>
                    part.PK_Stock_ID === selectedPartID
                        ? {
                            ...part,
                            LocationID: selectedDepotData.PK_StockLocation_ID,
                            DepotName: selectedDepotData.vc_Name,
                            DepotQuantity: selectedDepotData.dec_Quantity
                        }
                        : part
                )
            );

            setSelectedPartID(null);
            setSelectedDepot("");
            closeModal();

            return;
        }

        // Existing saved part
        JobPartsService.AddStockLocation(
            redirectCallback,
            IssueStockID,
            selectedDepot
        );

        fetchJobParts(currentPage, pageSize);

        setSelectedDepot("");
        closeModal();
    };
    const handleAddRow = () => {
        const newRow = {
            tempID: `text-${Date.now()}`,
            vc_StockCode: "S1",
            vc_Description: "Free Text",
            vc_StockName: "Free Text",
            mon_SalesPrice: "0.00",
            vc_UnitOfSale: "0.00",
            dec_QtyAllocated: "0.00",
            Measurment: "",
            DepotName: "",
            LocationID: 0,
            PK_Stock_ID: 0,
            IsTextRow: true
        };

        setSelectedParts(prev => [
            ...prev,
            newRow
        ]);
    };
    const handleTextRowChange = (tempID, field, value) => {

        if (field === "mon_SalesPrice" || field === "vc_UnitOfSale") {
            const decimalRegex = /^\d*\.?\d*$/;

            if (!decimalRegex.test(value)) {
                return;
            }
        }

        setSelectedParts(prevParts =>
            prevParts.map(part => {

                if (part.tempID !== tempID) {
                    return part;
                }

                // Keep Stock Name same as Description
                if (field === "vc_Description") {
                    return {
                        ...part,
                        vc_Description: value,
                        vc_StockName: value
                    };
                }

                return {
                    ...part,
                    [field]: value
                };
            })
        );
    };

    const defaultWidths = {
        partCode: 120,
        description: 250,
        depot: 180,
        salePrice: 120,
        quantity: 100,
        allocated: 100,
        status: 100,
        actions: 80
    };

    const COLUMN_COOKIE = `JobStockColumnWidths_${CompanyID}_${UserID}`;

    const [columnWidths, setColumnWidths] = useState(() => {
        const saved = Cookies.get(COLUMN_COOKIE);

        if (!saved) return defaultWidths;

        try {
            return {
                ...defaultWidths,
                ...JSON.parse(saved)
            };
        } catch {
            return defaultWidths;
        }
    });
    const startX = useRef(0);
    const startWidth = useRef(0);
    const resizingColumn = useRef(null);
    const MIN_COL_WIDTH = 60;

    const startResize = (e, key) => {
        e.stopPropagation();
        startX.current = e.clientX;
        resizingColumn.current = key;

        const th = e.target.closest("th");   // FIXED HERE
        startWidth.current = th.offsetWidth;

        document.addEventListener("mousemove", resizeColumn);
        document.addEventListener("mouseup", stopResize);
    };
    const resizeColumn = (e) => {
        if (!resizingColumn.current) return;

        const delta = e.clientX - startX.current;
        const newWidth = Math.max(startWidth.current + delta, MIN_COL_WIDTH);

        setColumnWidths(prev => ({
            ...prev,
            [resizingColumn.current]: newWidth
        }));
    };
    useEffect(() => {
        Cookies.set(
            COLUMN_COOKIE,
            JSON.stringify(columnWidths),
            { expires: 365 }
        );
    }, [columnWidths]);
    const stopResize = () => {
        document.removeEventListener("mousemove", resizeColumn);
        document.removeEventListener("mouseup", stopResize);

        resizingColumn.current = null;
    };


    const defaultColumns = [
        "vc_StockCode",
        "vc_Description",
        "DepotName",
        "mon_SalesPrice",
        "vc_UnitOfSale",
        "dec_QtyAllocated",
        "Action"
    ];
    const defaultColumnsForSearch = [
        "vc_StockCode",
        "vc_Description",
        "DepotName",
        "mon_SalesPrice",
        "vc_UnitOfSale",
        "dec_QtyAllocated",
        "Action"
    ];
    const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
    const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
    const columnOptions = [
        { value: "vc_StockCode", label: "Part Code" },
        { value: "vc_Description", label: "Description" },
        { value: "DepotName", label: "Depot" },
        { value: "mon_SalesPrice", label: "Sales Price" },
        { value: "vc_UnitOfSale", label: "Quantity" },
        { value: "dec_QtyAllocated", label: "Allocated" },
        { value: "Action", label: "Action" }
    ];

    const columnSearchOptions = [
        { value: "vc_StockCode", label: "Part Code" },
        { value: "vc_Description", label: "Description" },
        { value: "DepotName", label: "Depot" },
        { value: "mon_SalesPrice", label: "Sales Price" },
        { value: "vc_UnitOfSale", label: "Quantity" },
        { value: "dec_QtyAllocated", label: "Allocated" },
         { value: "Action", label: "Action" }
    ];
    const handleSearchColumnChange = (selectedOptions) => {
        setSearchColumns(selectedOptions);

    };
    const getStoredColumns = () => {
        const storedColumns = Cookies.get(`JobPartColumns_${CompanyID}`);
        return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
    };

    const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
    const handleColumnChange = (selectedOptions) => {
        setVisibleColumns(selectedOptions);

        // Save selection to cookies (valid for 1 year)
        Cookies.set(`JobPartColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
    };
    const handlePageChange = (page) => {
        setJobPartsData([]);
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);

        }
    };
    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    return (
        <div>
            <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                <div className="col-sm-6">
                    <button className={`btn btn-primary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleCreateJobPartClick} disabled={isClosed === '1' || isClosed === 1}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                    <button className={`btn btn-secondary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} style={{ "marginLeft": "5px" }} type="button" aria-label="Close" onClick={() => handleJobSaveClick(JobID)} disabled={isClosed === '1' || isClosed === 1}>
                        <i className="icofont-save" aria-hidden="true"> Allocate</i>
                    </button>

                    <button type="button" className={`btn btn-secondary btn-sm ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} onClick={handleAddRow} style={{ marginLeft: "10px" }}>
                        <i className="icofont-plus" aria-hidden="true">Add Text</i>
                    </button>
                </div>
                <div className="col-sm-6" style={{ textAlign: 'right' }}>

                </div>
            </div>
            <div className='divTable'>

                <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                    <div className="col-sm-12">
                        <div style={{ maxHeight: "450px", overflow: "auto" }}>

                            <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                <thead>
                                    <tr>
                                        <th
                                            style={{ width: columnWidths.partCode }}
                                        >
                                            <div className="resizable ellipsis">
                                                Part Code
                                                <div
                                                    className="resize-handle"
                                                    onMouseDown={(e) => startResize(e, "partCode")}
                                                />
                                            </div>
                                        </th>
                                        <th
                                            style={{ width: columnWidths.description }}
                                        >
                                            <div className="resizable ellipsis">
                                                Description
                                                <div
                                                    className="resize-handle"
                                                    onMouseDown={(e) => startResize(e, "description")}
                                                />
                                            </div>
                                        </th>
                                        <th
                                            style={{ width: columnWidths.depot }}
                                        >
                                            <div className="resizable ellipsis">
                                                Depot
                                                <div
                                                    className="resize-handle"
                                                    onMouseDown={(e) => startResize(e, "depot")}
                                                />
                                            </div>
                                        </th>
                                        <th
                                            style={{ width: columnWidths.salePrice }}
                                        >
                                            <div className="resizable ellipsis">
                                                Sale Price
                                                <div
                                                    className="resize-handle"
                                                    onMouseDown={(e) => startResize(e, "salePrice")}
                                                />
                                            </div>
                                        </th>
                                        <th
                                            style={{ width: columnWidths.quantity }}
                                        >
                                            <div className="resizable ellipsis">
                                                Quantity
                                                <div
                                                    className="resize-handle"
                                                    onMouseDown={(e) => startResize(e, "quantity")}
                                                />
                                            </div>
                                        </th>
                                        <th
                                            style={{ width: columnWidths.allocated }}
                                        >
                                            <div className="resizable ellipsis">
                                                Allocated
                                                <div
                                                    className="resize-handle"
                                                    onMouseDown={(e) => startResize(e, "allocated")}
                                                />
                                            </div>
                                        </th>
                                        <th
                                            style={{ width: columnWidths.status }}
                                        >
                                            <div className="resizable ellipsis">
                                                Status
                                                <div
                                                    className="resize-handle"
                                                    onMouseDown={(e) => startResize(e, "status")}
                                                />
                                            </div>
                                        </th>
                                        <th style={{ textAlign: "right" }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allParts.map((part, index) => (
                                        <tr
                                            key={
                                                part.IsNew
                                                    ? `new-${part.PK_Stock_ID}`
                                                    : `saved-${part.PK_IssueStock_ID}`
                                            }
                                            style={{
                                                backgroundColor: (part.locFreeStock > 0 && part.vc_UnitOfSale > part.dec_QtyAllocated) ? '#e0ffe0' : 'inherit' // Light green background if conditions are met
                                            }}
                                        >
                                            <td className="no-wrap" style={{
                                                width: columnWidths.partCode,
                                                maxWidth: columnWidths.partCode
                                            }}>
                                                {part.IsTextRow ? (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={part.vc_StockCode ?? ""}
                                                        onChange={(e) =>
                                                            handleTextRowChange(
                                                                part.tempID,
                                                                "vc_StockCode",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    <span title={part.vc_StockCode}>
                                                        {part.vc_StockCode}
                                                    </span>
                                                )}
                                            </td>
                                            <td className="no-wrap" style={{
                                                width: columnWidths.description,
                                                maxWidth: columnWidths.description
                                            }}>
                                                {part.IsTextRow ? (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={part.vc_Description ?? ""}
                                                        onChange={(e) =>
                                                            handleTextRowChange(
                                                                part.tempID,
                                                                "vc_Description",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    <span title={part.vc_Description}>
                                                        {part.vc_Description}
                                                    </span>

                                                )}
                                            </td>
                                            <td className="no-wrap" style={{
                                                width: columnWidths.depot,
                                                maxWidth: columnWidths.depot
                                            }}>

                                                {part.IsTextRow ? (

                                                    <span className="text-muted">N/A</span>

                                                ) : part.PK_IssueStock_ID ? (

                                                    part.DepotName ? (
                                                        part.DepotName
                                                    ) : part.FK_Stock_ID > 0 &&
                                                        part.StockType?.toString() === "1" ? (
                                                        <button
                                                            className="btn btn-primary btn-sm"
                                                            onClick={(event) =>
                                                                handelSelectDepot(
                                                                    event,
                                                                    part.PK_IssueStock_ID,
                                                                    part.FK_Stock_ID
                                                                )
                                                            }
                                                        >
                                                            Add Depot
                                                        </button>
                                                    ) : null

                                                ) : (

                                                    part.StockType?.toString() === "1" ? (
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-sm"
                                                            style={{ fontSize: "11px", padding: "3px 6px" }}
                                                            onClick={() =>
                                                                handleSelectDepotForNewPart(part.PK_Stock_ID)
                                                            }
                                                        >
                                                            {part.DepotName ? (
                                                                <>
                                                                    {part.DepotName}
                                                                    <small>
                                                                        ({part.DepotQuantity})
                                                                    </small>
                                                                </>
                                                            ) : (
                                                                "Add Depot"
                                                            )}
                                                        </button>
                                                    ) : null

                                                )}

                                            </td>
                                            <td className="no-wrap" style={{
                                                width: columnWidths.salePrice,
                                                maxWidth: columnWidths.salePrice
                                            }}>
                                                {part.IsTextRow ? (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={part.mon_SalesPrice ?? ""}
                                                        onChange={(e) =>
                                                            handleTextRowChange(
                                                                part.tempID,
                                                                "mon_SalesPrice",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    <>
                                                        {part.Symbol}
                                                        {parseFloat(
                                                            ConvRate * part.mon_SalesPrice
                                                        ).toFixed(2)}
                                                    </>
                                                )}
                                            </td>
                                            <td className="no-wrap" style={{
                                                width: columnWidths.quantity,
                                                maxWidth: columnWidths.quantity
                                            }}>
                                                {part.IsTextRow ? (
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={part.vc_UnitOfSale ?? ""}
                                                        onChange={(e) =>
                                                            handleTextRowChange(
                                                                part.tempID,
                                                                "vc_UnitOfSale",
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                ) : part.PK_IssueStock_ID ? (
                                                    <>
                                                        {part.vc_UnitOfSale} {part.Measurment}
                                                    </>
                                                ) : (
                                                    <>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={part.vc_UnitOfSale ?? ""}
                                                            onChange={(e) =>
                                                                handleQuantityChange(
                                                                    part.PK_Stock_ID,
                                                                    e.target.value
                                                                )
                                                            }
                                                        />

                                                    </>
                                                )}
                                            </td>
                                            <td className="no-wrap" style={{
                                                width: columnWidths.allocated,
                                                maxWidth: columnWidths.allocated
                                            }}>
                                                {part.IsTextRow
                                                    ? "0.00"
                                                    : `${part.dec_QtyAllocated} ${part.Measurment ?? ""}`}
                                            </td>
                                            <td className="no-wrap" style={{
                                                width: columnWidths.status,
                                                maxWidth: columnWidths.status
                                            }}>
                                                <PartStatus part={part} />
                                            </td>
                                            <td style={{ textAlign: "right" }}>
                                                <button style={{ background: "none", border: "none" }} className="text-danger" disabled={isClosed === '1' || isClosed === 1} onClick={(event) => handleDeleteClick(event, part)}>
                                                    <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                </button>
                                            </td>
                                        </tr>

                                    ))}
                                </tbody>
                                <tfoot style={{ position: "sticky", bottom: 0, zIndex: 2, backgroundColor: "white" }}>
                                    <tr>
                                        <td colSpan={visibleColumns.length + 1}>
                                            <div className="pagination-controls" style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                Showing {1 + (currentPage * pageSize) - pageSize} to {currentPage * (Math.min(poCount, pageSize))} of {poCount} entries

                                                {/* Last Page Button */}
                                                <button
                                                    style={{ float: "right", marginLeft: "5px" }}
                                                    className='btn btn-info'
                                                    onClick={() => handlePageChange(totalPages)} // Navigate to last page
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <img src="assets/img/resources/last.png" alt="Add icon" style={{ height: "10px" }} />  Last
                                                </button>

                                                {/* Next Page Button */}
                                                <button
                                                    style={{ float: "right", marginLeft: "5px" }}
                                                    className='btn btn-info'
                                                    onClick={() => handlePageChange(currentPage + 1)}
                                                    disabled={currentPage === totalPages}
                                                >
                                                    <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} />  Next
                                                </button>

                                                <span style={{ marginLeft: "10px", marginRight: "10px", float: "right" }}>
                                                    Page {currentPage} of {totalPages}
                                                </span>

                                                {/* Previous Page Button */}
                                                <button
                                                    style={{ float: "right", marginRight: "5px", marginLeft: "5px" }}
                                                    className='btn btn-info'
                                                    onClick={() => handlePageChange(currentPage - 1)}
                                                    disabled={currentPage === 1}
                                                >
                                                    <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} /> Prev
                                                </button>

                                                {/* First Page Button */}
                                                <button
                                                    style={{ float: "right" }}
                                                    className='btn btn-info'
                                                    onClick={() => handlePageChange(1)} // Navigate to first page
                                                    disabled={currentPage === 1}
                                                >
                                                    <img src="assets/img/resources/first.png" alt="Add icon" style={{ height: "10px" }} />   First
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {isModalDepot && (
                <div className="modal fade jobDepotModel show d-block" id="jobDepotModel" tabIndex="-1" aria-labelledby="jobDepotModelLabel" aria-hidden="true" data-backdrop="static">
                    <div className="modal-dialog modal-sm">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">Add Depot</h5>
                                <button type="button" className="close" aria-label="Close" onClick={closeModal}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ "maxHeight": "300px", "overflow": "auto", "marginTop": "20px" }}>
                                <div className="row mb-3" style={{ "marginLeft": "0px", 'marginRight': '0px' }}>
                                    <label htmlFor="CompanyName" className="col-sm-5 col-form-label">Select Depot</label>

                                    <div className="col-sm-7">
                                        <select className='form-control' value={selectedDepot} onChange={(e) => setSelectedDepot(e.target.value)}>
                                            <option value="">Select Depot</option>
                                            {depots.map((depot) => (
                                                <option value={depot.PK_StockLocation_ID}>
                                                    {depot.vc_Name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "0px", 'marginRight': '0px', float: "right" }}>
                                    <div className="col-sm-12">
                                        <button onClick={handleDepotSubmit} className="btn btn-primary">
                                            Save
                                        </button>
                                    </div>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            )}
            <div
                className="row mt-3 mb-3"
                style={{ marginLeft: "-5px", marginRight: "-5px" }}
            >
                <div className="col-12 text-end" >
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleFormSubmit}
                        disabled={isClosed === '1' || isClosed === 1}
                        style={{ float: "right" }}
                    >
                        <img
                            src="assets/img/resources/update-icon.png"
                            alt="Save icon"
                            style={{ height: "10px", marginRight: "5px" }}
                        />
                        Save
                    </button>
                </div>
            </div>

            {isModalOpen && (
                <CreateJobModel jobPart={currentjobPart} onClose={handleCloseModal} onSuccess={handleSuccess} JobID={JobID} />
            )}
            <PartSelectionModal
                show={showPartModal}
                onClose={() => setShowPartModal(false)}
                parts={partList}
                onSelectPart={handlePartSelect}
            />
        </div>
    );
}

export default JobPartList;
